import React from "react";
import {
  Layout,
  Avatar,
  Typography,
  Button,
  Flex,
} from "antd";
import { UserOutlined, MenuOutlined } from "@ant-design/icons";
import { DashboardIcon } from "../../../assets/CustomIcon";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUserData, selectUser } from "../../../redux/userSlice";
import { getJwtPayload } from "../../../utils/appUtils";
import LoginNavigation from "../Menus/LoginNavigation";

const { Header } = Layout;
const { Text } = Typography;

export default function SiteHeader({
  title,
  sidebarWidth = 0,
  isMobile = false,
  onToggleMobileMenu,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const HEADER_HEIGHT = 64;

  let decodedUser = null;
  try {
    if (user?.token) {
      decodedUser = getJwtPayload(user.token);
    } else if (typeof user === "string") {
      const token = localStorage.getItem("authToken");
      decodedUser = getJwtPayload(token);
    }
  } catch (error) {
    console.error("Failed to decode user token:", error);
  }

  const displayName =
    `${decodedUser?.first_name || ""} ${decodedUser?.last_name || ""}`.trim() ||
    decodedUser?.name ||
    "Admin User";

  const handleLogout = () => {
    dispatch(clearUserData());
    navigate("/");
  };

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case "dashboard":
        navigate("/dashboard");
        break;
      case "logoutButton":
        handleLogout();
        break;
      default:
        break;
    }
  };

  const headerStyle = {
    left: isMobile ? 0 : sidebarWidth,
    height: HEADER_HEIGHT,
    width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
  };

  const profileDropdown = [
    {
      key: "profileInfo",
      label: (
        <div>
          <div>{displayName}</div>
          <div>{decodedUser?.email || decodedUser?.email_id || ""}</div>
        </div>
      ),
      icon: (
        <span className="dropdownItemIcon">
          <Avatar icon={<UserOutlined />} />
        </span>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "dashboard",
      label: "Dashboard",
      icon: (
        <span className="dropdownItemIcon">
          <DashboardIcon />
        </span>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "logoutButton",
      label: "Logout",
      danger: true,
      icon: (
        <span className="dropdownItemIcon">
          <span className="material-symbols-outlined">logout</span>
        </span>
      ),
    },
  ];

  return (
    <Header style={headerStyle} className="pageHeader">
      <Flex align="center" justify="space-between" gap={12} style={{ flex: 1 }}>
        {isMobile && (
          <Button
            icon={<MenuOutlined />}
            type="text"
            onClick={onToggleMobileMenu}
          />
        )}
        <Text ellipsis className="pageHeaderTitle">
          {title}
        </Text>

        <Flex
          align="center"
          justify="center"
          gap={12}
          className="pageHeaderRight"
        >
          <LoginNavigation
            handleMenuClick={handleMenuClick}
            profileDropdown={profileDropdown}
          />
        </Flex>
      </Flex>
    </Header>
  );
}
